import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup, Button } from 'reactstrap';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import {
    getLegacyPatentes,
    getLegacyPersonas,
    getLegacyTiposTrabajoOt
} from '../../slices/thunks';
import useUpdateRecepcionVehiculo from '../Hooks/useUpdateRecepcionVehiculo';
import useRecepcionVehiculoPorId from '../Hooks/useRecepcionVehiculoPorId';

const ModalModificarRecepcionVehiculo = ({ isOpen, toggle, onSave, selectedRecepcion }) => {
    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const [formData, setFormData] = useState({
        patente: '',
        contacto: '',
        email: '',
        telefono: '',
        solicitud_cliente: '',
        // Add other fields as needed
    });

    const patentes = useSelector((state) => state.LegacyPatentes.legacyPatentes);
    const personas = useSelector((state) => state.LegacyPersonas.legacyPersonas);
    const tiposTrabajoOt = useSelector((state) => state.LegacyTiposTrabajoOt.legacyTiposTrabajoOt);
    const dispatch = useDispatch();

    const { recepcion, loading: loadingRecepcion } = useRecepcionVehiculoPorId(isOpen ? selectedRecepcion : null);
    const { updateRecepcionVehiculo, loading: updating } = useUpdateRecepcionVehiculo();

    useEffect(() => {
        if (recepcion && Object.keys(recepcion).length > 0) {
            setFormData({
                patente: recepcion.patent || recepcion.patente || '',
                contacto: recepcion.contacto || '',
                email: recepcion.email || '',
                telefono: recepcion.telefono || '',
                solicitud_cliente: recepcion.solicitud_cliente || '',
                // Populate other fields
            });
        }
    }, [recepcion]);

    useEffect(() => {
        if (isOpen) {
            dispatch(getLegacyPatentes({ tenantId, empresa }));
            dispatch(getLegacyPersonas({ tenantId, empresa }));
            dispatch(getLegacyTiposTrabajoOt({ tenantId, empresa }));
        }
    }, [isOpen, tenantId, empresa, dispatch]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await updateRecepcionVehiculo(selectedRecepcion, formData);
        if (result.success) {
            onSave();
            toggle();
        } else {
            alert('Error al actualizar recepción: ' + result.error);
        }
    };

    const handleCancel = () => {
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="ri-car-line me-2"></i>
                Modificar Recepción de Vehículo
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {loadingRecepcion ? (
                        <div className="text-center">Cargando datos de la recepción...</div>
                    ) : (
                        <>
                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="patente">Patente</Label>
                                        <Input
                                            type="text"
                                            id="patente"
                                            name="patente"
                                            value={formData.patente}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="contacto">Contacto</Label>
                                        <Input
                                            type="text"
                                            id="contacto"
                                            name="contacto"
                                            value={formData.contacto}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="email">Email</Label>
                                        <Input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="telefono">Teléfono</Label>
                                        <Input
                                            type="text"
                                            id="telefono"
                                            name="telefono"
                                            value={formData.telefono}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <FormGroup>
                                        <Label for="solicitud_cliente">Solicitud cliente</Label>
                                        <Input
                                            type="textarea"
                                            id="solicitud_cliente"
                                            name="solicitud_cliente"
                                            value={formData.solicitud_cliente}
                                            onChange={handleInputChange}
                                            rows="3"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            {/* Add more fields as needed */}
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-light" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <Button type="submit" color="success" disabled={updating}>
                        <i className="ri-save-line me-1"></i>
                        Actualizar
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalModificarRecepcionVehiculo;